import React, { useState, useMemo, useEffect, useCallback } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  LineChart,
  Line,
} from 'recharts';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.forwardsflow.com/api/v1';

const YIELD_DATA = {
  Kenya: [
    { instrument: '91-day T-bill', frontierYield: 8.8, usTreasuryYield: 3.9 },
    { instrument: '182-day T-bill', frontierYield: 9.2, usTreasuryYield: 3.9 },
    { instrument: '364-day T-bill', frontierYield: 10.1, usTreasuryYield: 3.9 },
    { instrument: '2-year bond', frontierYield: 11.5, usTreasuryYield: 3.9 },
    { instrument: '5-year bond', frontierYield: 12.8, usTreasuryYield: 3.9 },
    { instrument: '10-year bond', frontierYield: 14.2, usTreasuryYield: 3.9 },
    { instrument: 'Infra bond', frontierYield: 13.5, usTreasuryYield: 0, taxExempt: true },
  ],
  India: [
    { instrument: '91-day T-bill', frontierYield: 6.8, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 6.9, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 7.0, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 7.0, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 7.1, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 7.2, usTreasuryYield: 4.1 },
  ],
  Brazil: [
    { instrument: '91-day T-bill', frontierYield: 13.25, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 13.5, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 13.75, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 13.0, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 12.5, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 12.0, usTreasuryYield: 4.1 },
  ],
  Mexico: [
    { instrument: '91-day T-bill', frontierYield: 11.0, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 11.2, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 11.5, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 10.8, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 10.5, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 10.2, usTreasuryYield: 4.1 },
  ],
  Turkey: [
    { instrument: '91-day T-bill', frontierYield: 45.0, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 43.0, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 40.0, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 35.0, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 30.0, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 28.0, usTreasuryYield: 4.1 },
  ],
  Bangladesh: [
    { instrument: '91-day T-bill', frontierYield: 8.5, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 9.0, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 9.5, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 10.0, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 10.5, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 11.0, usTreasuryYield: 4.1 },
  ],
  'South Africa': [
    { instrument: '91-day T-bill', frontierYield: 7.5, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 8.0, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 8.5, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 9.0, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 9.5, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 10.5, usTreasuryYield: 4.1 },
  ],
  Egypt: [
    { instrument: '91-day T-bill', frontierYield: 25.5, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 26.0, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 26.5, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 24.0, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 22.0, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 20.0, usTreasuryYield: 4.1 },
  ],
  Ethiopia: [
    { instrument: '91-day T-bill', frontierYield: 14.0, usTreasuryYield: 5.2 },
    { instrument: '182-day T-bill', frontierYield: 14.5, usTreasuryYield: 4.8 },
    { instrument: '364-day T-bill', frontierYield: 15.0, usTreasuryYield: 4.5 },
    { instrument: '2-year bond', frontierYield: 15.5, usTreasuryYield: 4.3 },
    { instrument: '5-year bond', frontierYield: 16.0, usTreasuryYield: 4.2 },
    { instrument: '10-year bond', frontierYield: 16.5, usTreasuryYield: 4.1 },
  ],
};

const COUNTRIES = Object.keys(YIELD_DATA);
const PERIODS = [
  { key: 'current', label: 'Current' },
  { key: '3M', label: '3M' },
  { key: '6M', label: '6M' },
  { key: '1Y', label: '1Y' },
  { key: '5Y', label: '5Y' },
  { key: '10Y', label: '10Y' },
];

const TENORS = [
  { key: 'All', label: 'All' },
  { key: '91-day T-bill', label: '91-day T-bill' },
  { key: '182-day T-bill', label: '182-day T-bill' },
  { key: '364-day T-bill', label: '364-day T-bill' },
];

const SOURCES = [
  { key: 'USD', label: 'USD' },
  { key: 'CHF', label: 'CHF' },
  { key: 'AED', label: 'AED' },
  { key: 'GBP', label: 'GBP' },
  { key: 'JPY', label: 'YEN' },
];

const SOURCE_LONG_LABELS = {
  USD: 'US Treasury',
  CHF: 'Swiss Govt',
  AED: 'UAE Govt',
  GBP: 'UK Gilt',
  JPY: 'Japan Govt (JGB)',
};

const FF_FEE = 1.5;

const CustomTooltip = ({ active, payload, label, sourceLongLabel = 'US Treasury' }) => {
  if (!active || !payload || !payload.length) return null;
  const frontier = payload.find((p) => p.dataKey === 'frontierYield');
  const us = payload.find((p) => p.dataKey === 'usTreasuryYield');
  const diff =
    frontier && us ? (frontier.value - us.value).toFixed(1) : '—';
  return (
    <div className="bg-white border border-zinc-300 p-4 text-xs font-sans shadow-sm">
      <p className="font-mono uppercase tracking-wider text-zinc-500 mb-2">{label}</p>
      {frontier && (
        <p className="text-black">
          Frontier yield: <span className="font-bold">{frontier.value}%</span>
        </p>
      )}
      {us && us.value !== 0 && (
        <p className="text-zinc-500">
          {sourceLongLabel} equivalent: <span className="font-bold">{us.value}%</span>
        </p>
      )}
      {us && us.value === 0 && (
        <p className="text-zinc-500 italic">Tax-exempt — no direct {sourceLongLabel} equivalent</p>
      )}
      <p className="mt-1 text-black font-semibold">
        Differential: +{diff}pp
      </p>
    </div>
  );
};

const LineChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-white border border-zinc-300 p-3 text-xs font-sans shadow-sm">
      <p className="font-mono uppercase tracking-wider text-zinc-500 mb-1">{label}</p>
      {payload.map((p, i) => (
        <p key={i} style={{ color: p.color }}>
          {p.name}: <span className="font-bold">{p.value}%</span>
        </p>
      ))}
    </div>
  );
};

const YieldDifferentialExplorer = () => {
  const [selectedCountry, setSelectedCountry] = useState('Kenya');
  const [selectedPeriod, setSelectedPeriod] = useState('current');
  const [selectedTenor, setSelectedTenor] = useState('All');
  const [selectedSource, setSelectedSource] = useState('USD');
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sourceLongLabel = SOURCE_LONG_LABELS[selectedSource] || 'US Treasury';

  const fetchYields = useCallback(async (country, period, source) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${API_BASE}/yields?country=${encodeURIComponent(country)}&period=${encodeURIComponent(period)}&source=${encodeURIComponent(source)}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      if (!json.success) throw new Error(json.error || 'API error');
      setApiData(json.data);
    } catch (err) {
      setError(err.message);
      setApiData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchYields(selectedCountry, selectedPeriod, selectedSource);
  }, [selectedCountry, selectedPeriod, selectedSource, fetchYields]);

  // For historical periods, show yields from the START of the period
  // For current, show the latest snapshot
  const data = useMemo(() => {
    let instruments;
    if (selectedPeriod !== 'current' && apiData?.timeSeries?.length) {
      // Use the first time series snapshot (start of the selected period)
      instruments = apiData.timeSeries[0].instruments.map((y) => ({
        instrument: y.instrument,
        frontierYield: y.frontierYield,
        usTreasuryYield: y.usTreasuryYield,
        taxExempt: y.taxExempt,
      }));
    } else if (apiData?.yields?.length) {
      instruments = apiData.yields.map((y) => ({
        instrument: y.instrument,
        frontierYield: y.frontierYield,
        usTreasuryYield: y.usTreasuryYield,
        taxExempt: y.taxExempt,
      }));
    } else {
      instruments = (YIELD_DATA[selectedCountry] || []).map((d) => ({
        ...d,
        usTreasuryYield: selectedSource !== 'USD' ? 0 : d.usTreasuryYield,
      }));
    }
    if (selectedTenor !== 'All') {
      instruments = instruments.filter((d) => d.instrument === selectedTenor);
    }
    return instruments;
  }, [apiData, selectedCountry, selectedPeriod, selectedTenor, selectedSource]);

  // Date label for the bar chart
  const dataDateLabel = useMemo(() => {
    if (selectedPeriod !== 'current' && apiData?.timeSeries?.length) {
      const rd = apiData.timeSeries[0].recordDate;
      const [y, m] = rd.split('-');
      const d = new Date(Date.UTC(parseInt(y), parseInt(m) - 1, 1));
      return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
    }
    if (apiData?.yields?.length && apiData.yields[0]?.recordDate) {
      const rd = apiData.yields[0].recordDate;
      const [y, m] = rd.split('-');
      const d = new Date(Date.UTC(parseInt(y), parseInt(m) - 1, 1));
      return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
    }
    return null;
  }, [apiData, selectedPeriod]);

  const bestInstrument = useMemo(() => {
    if (!data.length) return null;
    return data.reduce((best, cur) =>
      cur.frontierYield > best.frontierYield ? cur : best
    );
  }, [data]);

  // Prepare line chart data from time series
  // Uses actual historical FX rates to compute trailing 12-month currency depreciation
  const lineChartData = useMemo(() => {
    if (!apiData?.timeSeries?.length || selectedPeriod === 'current') return null;

    const bestName = bestInstrument?.instrument;
    if (!bestName) return null;

    // Build FX rate lookup from the dedicated fxRates array (includes 12-month lookback)
    const fxRateMap = new Map();
    if (apiData.fxRates?.length) {
      for (const fx of apiData.fxRates) {
        fxRateMap.set(fx.recordDate, fx.usdRate);
      }
    }

    return apiData.timeSeries.map((snapshot) => {
      const bestInst = snapshot.instruments.find((i) => i.instrument === bestName);
      const frontierYield = bestInst?.frontierYield ?? null;

      // Compute trailing 12-month FX depreciation from actual exchange rates
      let fxAdjustedYield = null;
      const currentRate = snapshot.fxRate ?? fxRateMap.get(snapshot.recordDate);
      if (frontierYield !== null && currentRate != null) {
        // Find rate from 12 months earlier
        const [y, m] = snapshot.recordDate.split('-');
        const priorDate = new Date(Date.UTC(parseInt(y) - 1, parseInt(m) - 1, 1));
        const priorKey = `${priorDate.getUTCFullYear()}-${String(priorDate.getUTCMonth() + 1).padStart(2, '0')}-01`;
        const priorRate = fxRateMap.get(priorKey);

        if (priorRate != null && priorRate > 0) {
          // Annual depreciation: (currentRate - priorRate) / priorRate * 100
          // Positive value = currency weakened (more local currency per USD)
          const annualDepreciation = ((currentRate - priorRate) / priorRate) * 100;
          // Effective USD yield = local yield - depreciation cost
          fxAdjustedYield = parseFloat((frontierYield - annualDepreciation).toFixed(2));
        }
      }

      const [y, m] = snapshot.recordDate.split('-');
      const date = new Date(Date.UTC(parseInt(y), parseInt(m) - 1, 1));
      const label = date.toLocaleDateString('en-US', { month: 'short', year: '2-digit', timeZone: 'UTC' });
      return {
        date: label,
        frontierYield,
        fxAdjustedYield,
        usTreasuryYield: bestInst?.usTreasuryYield ?? null,
      };
    });
  }, [apiData, selectedPeriod, bestInstrument]);

  const netYield = bestInstrument
    ? (bestInstrument.frontierYield - FF_FEE).toFixed(1)
    : '—';
  const differential = bestInstrument
    ? (bestInstrument.frontierYield - bestInstrument.usTreasuryYield).toFixed(1)
    : '—';

  return (
    <div>
      {/* Country selector + Period selector */}
      <div className="mb-8 flex flex-wrap items-center gap-4">
        <label
          htmlFor="country-select"
          className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-500"
        >
          Select market
        </label>
        <select
          id="country-select"
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
          className="font-mono text-xs uppercase tracking-[0.15em] border border-zinc-300 bg-white px-4 py-2 text-black focus:outline-none focus:border-[#4D4D4D]"
        >
          {COUNTRIES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <label
          htmlFor="tenor-select"
          className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-500"
        >
          Tenor
        </label>
        <select
          id="tenor-select"
          value={selectedTenor}
          onChange={(e) => setSelectedTenor(e.target.value)}
          className="font-mono text-xs uppercase tracking-[0.15em] border border-zinc-300 bg-white px-4 py-2 text-black focus:outline-none focus:border-[#4D4D4D]"
        >
          {TENORS.map((t) => (
            <option key={t.key} value={t.key}>
              {t.label}
            </option>
          ))}
        </select>

        <label
          htmlFor="source-select"
          className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-500"
        >
          Source
        </label>
        <select
          id="source-select"
          value={selectedSource}
          onChange={(e) => setSelectedSource(e.target.value)}
          className="font-mono text-xs uppercase tracking-[0.15em] border border-zinc-300 bg-white px-4 py-2 text-black focus:outline-none focus:border-[#4D4D4D]"
        >
          {SOURCES.map((s) => (
            <option key={s.key} value={s.key}>
              {s.label}
            </option>
          ))}
        </select>

        <div className="flex items-center gap-1">
          {PERIODS.map((p) => (
            <button
              key={p.key}
              onClick={() => setSelectedPeriod(p.key)}
              className={`font-mono text-xs uppercase tracking-[0.1em] px-3 py-1.5 border transition-colors ${
                selectedPeriod === p.key
                  ? 'bg-[#4D4D4D] text-white border-[#4D4D4D]'
                  : 'bg-white text-zinc-600 border-zinc-300 hover:border-zinc-400'
              }`}
              style={{ borderRadius: '9999px' }}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {/* Loading / Error states */}
      {loading && (
        <div className="mb-4 font-mono text-xs text-zinc-500 animate-pulse">
          Loading yield data...
        </div>
      )}
      {error && !loading && (
        <div className="mb-4 font-mono text-xs text-zinc-400">
          Showing latest available data — historical trends unavailable offline
        </div>
      )}

      {/* Bar Chart — shows yields for the selected period */}
      <div className="border border-zinc-300 bg-white p-6">
        {dataDateLabel && (
          <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-4">
            {selectedPeriod === 'current' ? 'Latest yields' : `Yields as of ${dataDateLabel}`}
            {selectedPeriod !== 'current' && ' — scroll down for trend'}
          </p>
        )}
        <ResponsiveContainer width="100%" height={380}>
          <BarChart
            data={data}
            margin={{ top: 10, right: 20, left: 0, bottom: 20 }}
            barGap={4}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e4e4e7" />
            <XAxis
              dataKey="instrument"
              tick={{ fontSize: 10, fontFamily: 'monospace', fill: '#71717a' }}
              angle={-30}
              textAnchor="end"
              height={60}
            />
            <YAxis
              tick={{ fontSize: 10, fontFamily: 'monospace', fill: '#71717a' }}
              tickFormatter={(v) => `${v}%`}
              domain={['auto', 'auto']}
            />
            <Tooltip content={<CustomTooltip sourceLongLabel={sourceLongLabel} />} />
            <Legend
              wrapperStyle={{ fontSize: 11, fontFamily: 'monospace' }}
              formatter={(value) =>
                value === 'frontierYield'
                  ? `${selectedCountry} yield`
                  : `${sourceLongLabel} equivalent`
              }
            />
            <Bar
              dataKey="frontierYield"
              fill="#4D4D4D"
              name="frontierYield"
              radius={[0, 0, 0, 0]}
            />
            <Bar
              dataKey="usTreasuryYield"
              fill="#d4d4d8"
              name="usTreasuryYield"
              radius={[0, 0, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Line Chart — shows when a historical period is selected */}
      {lineChartData && lineChartData.length > 0 && (
        <div className="mt-6 border border-zinc-300 bg-white p-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-4">
            {bestInstrument?.instrument} — yield trend ({selectedPeriod})
          </p>
          <ResponsiveContainer width="100%" height={280}>
            <LineChart
              data={lineChartData}
              margin={{ top: 10, right: 20, left: 0, bottom: 20 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#e4e4e7" />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 9, fontFamily: 'monospace', fill: '#71717a' }}
                angle={-30}
                textAnchor="end"
                height={50}
              />
              <YAxis
                tick={{ fontSize: 10, fontFamily: 'monospace', fill: '#71717a' }}
                tickFormatter={(v) => `${v}%`}
                domain={['auto', 'auto']}
              />
              <Tooltip content={<LineChartTooltip />} />
              <Legend
                wrapperStyle={{ fontSize: 11, fontFamily: 'monospace' }}
              />
              <Line
                type="monotone"
                dataKey="frontierYield"
                stroke="#4D4D4D"
                strokeWidth={2}
                dot={false}
                name={`${selectedCountry} yield`}
              />
              <Line
                type="monotone"
                dataKey="fxAdjustedYield"
                stroke="#3832e3"
                strokeWidth={2}
                dot={false}
                name="Effective yield (after foreign exchange)"
              />
              <Line
                type="monotone"
                dataKey="usTreasuryYield"
                stroke="#a1a1aa"
                strokeWidth={1.5}
                dot={false}
                strokeDasharray="4 3"
                name={sourceLongLabel}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* Summary panel */}
      {bestInstrument && (
        <div className="mt-6 border border-zinc-300 bg-zinc-50 p-6 grid sm:grid-cols-3 gap-6">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-1">
              {selectedTenor !== 'All'
                ? (selectedPeriod === 'current' ? 'Selected tenor' : `Selected tenor (${dataDateLabel || selectedPeriod})`)
                : (selectedPeriod === 'current' ? 'Best instrument' : `Best instrument (${dataDateLabel || selectedPeriod})`)}
            </p>
            <p className="font-sans text-sm font-bold text-black">
              {bestInstrument.instrument}
            </p>
            <p className="font-mono text-xs text-zinc-600 mt-0.5">
              {bestInstrument.frontierYield}% yield
              {bestInstrument.taxExempt && (
                <span className="ml-1 text-zinc-500 italic">(tax-exempt)</span>
              )}
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-1">
              Yield differential
            </p>
            <p className="font-sans text-sm font-bold text-black">
              +{differential} percentage points
            </p>
            <p className="font-mono text-xs text-zinc-600 mt-0.5">
              vs. equivalent {sourceLongLabel}
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-1">
              After Forwardsflow fees ({FF_FEE}%)
            </p>
            <p className="font-sans text-sm font-bold text-black">
              {netYield}% net yield
            </p>
            <p className="font-mono text-xs text-zinc-600 mt-0.5">
              Indicative — before foreign exchange hedging costs
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default YieldDifferentialExplorer;
